import { ChangelogBaseFragment } from '@cycle-app/graphql-codegen';
import { useForm } from 'react-hook-form';

// Make all strings for the equality check.
export type ChangelogBuilderFormData = Record<'title' | 'subtitle' | 'socialLinkText' | 'socialLinkURL', string>;

type Props = {
  changelog: ChangelogBaseFragment;
};

export const useChangelogBuilderForm = ({ changelog }: Props) => {
  return useForm<ChangelogBuilderFormData>({
    defaultValues: {
      socialLinkText: changelog.socialLinkText || '',
      socialLinkURL: changelog.socialLinkURL || '',
      title: changelog.title || '',
      subtitle: changelog.subtitle || '',
    },
  });
};
